// @flow strict
import React, { useEffect, useState } from "react";
import { PictureOutlined } from "@ant-design/icons";

function ProductVideoWidget(props) {
  const [videoUrl, setVideoUrl] = useState("");
  const { productInfo, setProductInfo } = props;
  const { errorField } = props;
  const { id } = props;

  useEffect(() => {
    if (productInfo.url) {
      setVideoUrl(productInfo.url);
    } else {
      setVideoUrl("");
    }

    return () => {
      // cleanup object URL
      if (videoUrl && videoUrl.startsWith("blob:")) {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [productInfo.url]);

  const onDropVideo = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const file = files[0];
    const previewUrl = URL.createObjectURL(file);

    setVideoUrl(previewUrl);
    setProductInfo({
      ...productInfo,
      video_name: file,
    });
  };

  return (
    <div className="product-video-widget">
      <label htmlFor={id ?? "upload_product_video"}>
        <input
          type="file"
          id={id ?? "upload_product_video"}
          name={id ?? "upload_product_video"}
          style={{ display: "none" }}
          accept="video/mp4,video/webm,video/ogg"
          onChange={onDropVideo}
        />

        {videoUrl ? (
          <video
            className={
              "product-video-widget-video " +
              (errorField.includes("video_name")
                ? "product-video-widget-error"
                : "")
            }
            src={videoUrl}
            controls
            preload="metadata"
          />
        ) : (
          <div
            className={
              "product-video-widget-placeholder " +
              (errorField.includes("video_name")
                ? "product-video-widget-error"
                : "")
            }
          >
            <PictureOutlined style={{ fontSize: 40 }} />
            <div>No video selected</div>
          </div>
        )}

        <div
          style={{
            textAlign: "center",
            cursor: "pointer",
            marginBottom: "10px",
          }}
        >
          Click here to insert video
        </div>
      </label>
    </div>
  );
}

export default ProductVideoWidget;
